import renderHTML from 'react-render-html'

export default function parseValidHtmlString(string) {
	return renderHTML(string)
}


// WEBPACK FOOTER //
// ./src/utilities/content/parseValidHtmlString.js